import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { Icon } from '@iconify/react'
import './TheSidebar.css'
import SignOutConfirmation from './SignOutConfirmation'

import { get_first_char_of_last_word } from '../../../utils/conversion'
import useLogoutMutation from '../../../features/login/hooks/useLogout'

const ICON_STYLE_CONFIG = {
  base: 'text-2xl basic-1/6 ml-6',
}

function SignOut() {
  const { user } = useSelector((state) => state.auth.data)
  const { logoutMutation } = useLogoutMutation()
  const [isOpen, setIsOpen] = useState(false)
  const [isSignout, setIsSignout] = useState(false)
  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleSignout = () => {
    logoutMutation.mutate()
  }

  const handleCancel = () => {
    setIsSignout(false)
  }

  const handleOverlayClick = () => {
    setIsSignout(true)
  }

  return (
    <section className="text-gray-accent">
      <div className="fixed bottom-[4rem] left-[2rem] w-[20vw]">
        <div
          className={`dropDownMenu relative z-50 rounded-[5px] bg-white ${
            isOpen ? 'active' : 'hidden'
          }`}
        >
          <div className="flex w-full cursor-pointer items-center justify-between border-b-[1px] border-gray-200 py-4">
            <Icon
              icon="ph:warning-circle-bold"
              className={ICON_STYLE_CONFIG.base}
            />
            <div className="ml-4 flex basis-5/6 items-center justify-between">
              <p className="basis-4/6 text-lg font-medium">Báo lỗi</p>
              <div className="basis-2/6"></div>
            </div>
          </div>
          <div className="flex w-full cursor-pointer items-center justify-between py-4">
            <Icon icon="ph:sign-out-bold" className={ICON_STYLE_CONFIG.base} />
            <div
              className="relative ml-4 flex basis-5/6 items-center justify-between"
              onClick={() => setIsSignout(true)}
            >
              <p
                className="basis-4/6 text-lg font-medium"
                onClick={handleOverlayClick}
              >
                Đăng xuất
              </p>
              <div className="basis-2/6"></div>
            </div>
          </div>
          {isSignout && (
            <SignOutConfirmation
              onCancel={handleCancel}
              onSignOut={handleSignout}
            />
          )}
        </div>
      </div>
      <div
        className="scroll-stable-center flex w-full cursor-pointer items-center justify-between overflow-hidden pb-8"
        onClick={handleToggle}
      >
        <div className="basic-1/6 ml-4 flex aspect-square min-w-[24px] items-center justify-center rounded-full bg-gray-accent">
          <p className="text-sm font-bold text-white">
            {get_first_char_of_last_word(user?.account?.name ?? user?.email)}
          </p>
        </div>
        <div className="ml-3 mr-6 flex basis-5/6 items-center justify-between">
          <p className="basis-4/6 text-lg font-semibold">
            {user?.account?.name.toUpperCase()}
          </p>
          <span>
            {isOpen ? (
              <Icon
                icon="ph:caret-up-bold"
                className={ICON_STYLE_CONFIG.base}
              />
            ) : (
              <Icon
                icon="ph:caret-down-bold"
                className={ICON_STYLE_CONFIG.base}
              />
            )}
          </span>
        </div>
      </div>
    </section>
  )
}

export default SignOut
